import { render, staticRenderFns } from "./ERegistrationProfessionalUpgradeView.vue?vue&type=template&id=4dddf8e1&scoped=true&"
import script from "./ERegistrationProfessionalUpgradeView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationProfessionalUpgradeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dddf8e1",
  null
  
)

export default component.exports